// Translation loader - manages dynamic loading of translations based on route
import { commonTranslations } from './common';
import { homeTranslations } from './home';

type Language = 'en' | 'pt';
type TranslationRecord = Record<string, string>;
type Translations = { en: TranslationRecord; pt: TranslationRecord };

// Merge two translation objects
const mergeTranslations = (base: Translations, additional: Translations): Translations => ({
  en: { ...base.en, ...additional.en },
  pt: { ...base.pt, ...additional.pt },
});

// Base translations (common + home) loaded synchronously for homepage
export const baseTranslations: Translations = mergeTranslations(commonTranslations, homeTranslations);

// Route to translation module mapping
const routeTranslationMap: Record<string, () => Promise<{ default: Translations } | Translations>> = {
  '/registo-yango-motorista-maputo': () => import('./registo').then(m => ({ default: m.registoTranslations })),
  '/cadastro-motorista-yango': () => import('./cadastro').then(m => ({ default: m.cadastroTranslations })),
  '/requisitos-motorista-yango': () => import('./requisitos').then(m => ({ default: m.requisitosTranslations })),
  '/baixar-yango-pro-maputo': () => import('./download').then(m => ({ default: m.downloadTranslations })),
  '/blog': () => import('./blog').then(m => ({ default: m.blogTranslations })),
  '/recarga-automatica-yango-pro-emola-mpesa': () => import('./recarga').then(m => ({ default: m.recargaTranslations })),
};

// Load translations for a specific route
export const loadTranslationsForRoute = async (pathname: string): Promise<Translations | null> => {
  // Check if route matches any translation module
  for (const [route, loader] of Object.entries(routeTranslationMap)) {
    if (pathname === route || pathname.startsWith(route + '/') || pathname.startsWith('/blog')) {
      try {
        const module = await loader();
        return 'default' in module ? module.default : module;
      } catch (error) {
        console.warn(`Failed to load translations for route: ${route}`, error);
        return null;
      }
    }
  }
  return null;
};

// Get route key from pathname
export const getRouteKey = (pathname: string): string | null => {
  for (const route of Object.keys(routeTranslationMap)) {
    if (pathname === route || pathname.startsWith(route + '/') || (route === '/blog' && pathname.startsWith('/blog'))) {
      return route;
    }
  }
  return null;
};
